import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";
import HomeHeader from "./components/HomeHeader";
import BottomNav from "./components/BottomNav";
import OrderCard from "./components/OrderCard";
import SubHeader from "./components/SubHeader";

const PENDING = ["T1", "T2", "T3"];

const Payment = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    if (!search.trim()) return PENDING;
    const q = search.toLowerCase();
    return PENDING.filter((t) => t.toLowerCase().includes(q));
  }, [search]);

  return (
    <>
      <MobileTailwind />
      <div id="mobile-root" className="h-screen w-full bg-black flex justify-center overflow-hidden">
        <div className="relative w-full h-screen overflow-y-auto overflow-x-hidden">
          {/* Background image + overlay */}
          <div className="absolute inset-0 z-0">
            <img src="/mobile-assets/login-bg.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/80" />
          </div>

          <div className="relative z-10">
            <SubHeader title="Payment" showBack={false} />
            <HomeHeader
              searchValue={search}
              onSearchChange={setSearch}
              searchPlaceholder="Search Table Number"
            />

            <div className="px-3 md:px-6 pt-3 pb-[120px]">
              <h2 className="font-sansation font-bold text-white text-[16px] mb-3">
                Ongoing Orders
              </h2>

              {filtered.length === 0 ? (
                <p className="text-center font-opensans text-[14px] text-[#F4F4F5] mt-6">
                  No pending payments
                </p>
              ) : (
                <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 gap-3">
                  {filtered.map((t) => (
                    <OrderCard
                      key={t}
                      tableNo={t}
                      variant="payment"
                      onClick={() => navigate(`/mobile/payment/${t}`)}
                    />
                  ))}
                </div>
              )}
            </div>
            <BottomNav active="payment" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
